<template>
  <router-view />
</template>

<script>
export default {
  name: "WorkView",
  data() {
    return {};
  }
};
</script>
